import { Link } from "react-router-dom";
import useSeo from "@/hooks/useSeo";
import PageHeader from "@/components/feature/PageHeader";
import Accordion from "@/components/base/Accordion";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/faqs";
import { site } from "@/mocks/site";

const faqJsonLd = [
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((item) => ({
      "@type": "Question",
      name: item.q,
      acceptedAnswer: { "@type": "Answer", text: item.a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "首页", item: "https://law818.cn/" },
      { "@type": "ListItem", position: 2, name: "常见问题", item: "https://law818.cn/faq" },
    ],
  },
];

export default function Faq() {
  useSeo({
    title: "常见问题 | 更新频率、投稿与内容原则 - 513吃瓜",
    description:
      "关于 513吃瓜的常见问题：内容多久更新一次、如何投稿二创与表情包、热梗为什么很快过气、内容是否有主观倾向等，一次说清楚。",
    keywords: "513吃瓜常见问题,513吃瓜怎么投稿,热梗更新频率,内容原则",
    path: "/faq",
    jsonLd: faqJsonLd,
  });

  return (
    <>
      <PageHeader
        eyebrow="帮助中心"
        title="常见问题"
        desc="把大家问得最多的几个问题整理在这里。如果还是没找到答案，欢迎直接联系我们，通常一到两个工作日内回复。"
        crumbs={[{ label: "首页", path: "/" }, { label: "常见问题" }]}
      />

      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-6 md:py-16 lg:grid-cols-[minmax(0,1fr)_300px]">
        <Reveal>
          <Accordion items={faqs} defaultOpen={0} />
        </Reveal>

        <aside className="space-y-5 lg:sticky lg:top-28 lg:self-start" aria-label="侧边栏">
          <div className="rounded-lg border border-background-200 bg-background-100 p-6">
            <h2 className="flex items-center gap-2 font-heading text-lg text-foreground-950">
              <i className="ri-customer-service-2-line text-primary-500" aria-hidden="true"></i>
              没找到答案？
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              把你的问题发给我们，编辑会尽量在一天内回复。
            </p>
            <Link
              to="/contact"
              className="mt-5 inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm text-background-50 hover:bg-primary-600"
            >
              联系编辑
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="font-heading text-lg text-foreground-950">联系我们</h2>
            <ul className="mt-4 space-y-3 text-sm text-foreground-600">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>{site.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-wechat-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>微信：{site.wechat}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-time-line mt-0.5 text-primary-500" aria-hidden="true"></i>
                <span>{site.workingHours}</span>
              </li>
            </ul>
          </div>
        </aside>
      </div>
    </>
  );
}